import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Countdown from "react-countdown";
import { RootState } from "store";
import { expireTempToken } from "store/actions/user";
import { decodeTempTokenExpiration } from "helpers/tempToken";
import { Typography } from "design_system/src";

type CountdownRendererProps = {
  minutes: number;
  seconds: number;
};

const countdownRenderer = ({ minutes, seconds }: CountdownRendererProps) => (
  <div className="text_center">
    <Typography
      scale="medium"
      weight="400"
      textColor="primary_300"
    >
      Sesión temporal, accede a Mi cuenta para hacer el seguimiento de tu solicitud.
    </Typography>
    <Typography
      scale="small"
      weight="600"
      textColor="primary_300"
    >
      Expira en: {minutes}:{String(seconds).padStart(2, "0")}
    </Typography>
  </div>
);

export const TempTokenCountdown: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tempToken = useSelector((state: RootState) => state.userReducer.tempToken);
  const [expired, setExpired] = useState(false);

  const targetDate = useMemo(
    () => (tempToken ? decodeTempTokenExpiration(tempToken) : null),
    [tempToken]
  );

  useEffect(() => {
    setExpired(false);
  }, [tempToken]);

  if (!tempToken || !targetDate || expired) return null;

  const handleComplete = () => {
    setExpired(true);
    dispatch(expireTempToken());
    Swal.fire({
      title: "Tu sesión ha expirado",
      text: "Ingresa a Mi Cuenta para continuar.",
      confirmButtonText: "Ir a Mi Cuenta",
      allowOutsideClick: false,
      customClass: {
        confirmButton: "bg_primary_300 w_90_per",
        title: "text_neutral_800",
        container: "text_neutral_700",
      },
    }).then(() => {
      navigate("/ingresar");
    });
  };

  return (
    <div className="w_100_per display_flex flex_center p_xs bg_primary_25">
      <Countdown
        date={targetDate}
        onComplete={handleComplete}
        renderer={countdownRenderer}
      />
    </div>
  );
};
